import { Ticket, ArrowUpRight } from "lucide-react";
import { EVENT_CONFIG, fmtUSD } from "@/config/eventConfig";
import { SectionHeading, Reveal } from "./shared";

const Tickets = () => {
  const { tickets, urls } = EVENT_CONFIG;

  return (
    <section id="tickets" data-testid="tickets-section" className="relative py-24 sm:py-32 bg-gradient-to-b from-ink via-wine/15 to-ink grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-14">
        <SectionHeading
          chapter="07"
          eyebrow="Tickets & Tables"
          title={
            <>
              YOUR SEAT IS <span className="gold-shimmer">WAITING.</span>
            </>
          }
          sub="Every ticket builds crowns. Early bird pricing ends October 1."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 w-full">
          {tickets.map((t, i) => {
            const featured = t.id === "early-bird";
            return (
              <Reveal key={t.id} delay={i * 0.06}>
                <div
                  data-testid={`ticket-card-${t.id}`}
                  className={`relative h-full rounded-3xl p-8 flex flex-col gap-5 transition-all duration-300 hover:-translate-y-1.5 ${
                    featured
                      ? "bg-gradient-to-b from-wine/50 to-coal gold-stroke shadow-[0_25px_60px_-20px_rgba(230,199,134,0.35)]"
                      : "bg-coal/70 border border-white/10 hover:border-champagne/30"
                  }`}
                >
                  {t.tag && (
                    <span className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-champagne text-ink text-[10px] uppercase tracking-[0.2em] font-bold">
                      {t.tag}
                    </span>
                  )}
                  <div className="flex items-center gap-3">
                    <Ticket size={18} className="text-gold" />
                    <h3 className="font-serif text-xl sm:text-2xl text-ivory">{t.name}</h3>
                  </div>
                  <div className="font-serif text-4xl sm:text-5xl gold-text">
                    {t.price ? fmtUSD(t.price) : "TBA"}
                  </div>
                  <p className="text-cream/70 text-sm leading-relaxed flex-1">{t.note}</p>
                  {t.scrollTo ? (
                    <a
                      data-testid={`ticket-card-${t.id}-buy-button`}
                      href={`#${t.scrollTo}`}
                      className="inline-flex items-center justify-center gap-2 py-3.5 rounded-full border border-champagne/50 text-champagne text-xs uppercase tracking-[0.2em] font-semibold hover:bg-champagne/10 transition-colors"
                    >
                      Explore <ArrowUpRight size={14} />
                    </a>
                  ) : (
                    <a
                      data-testid={`ticket-card-${t.id}-buy-button`}
                      href={urls.buyTickets}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`inline-flex items-center justify-center gap-2 py-3.5 rounded-full text-xs uppercase tracking-[0.2em] font-bold transition-all ${
                        featured
                          ? "bg-gradient-to-r from-gold via-champagne to-gold text-ink hover:shadow-[0_14px_35px_-10px_rgba(230,199,134,0.7)]"
                          : "border border-champagne/50 text-champagne hover:bg-champagne/10"
                      }`}
                    >
                      Buy Now <ArrowUpRight size={14} />
                    </a>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <p className="text-cream/50 text-xs uppercase tracking-[0.25em] text-center">
            Secure checkout via Styles 4 Kidz' official event page · VIP, table &amp; corporate pricing announced soon
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Tickets;
